  // coffeelint: disable
angular.module('gym.contactForm', ['gym.form']).factory('ContactForm', [
  'Form',
  function(Form,
  http) {
    var ContactForm;
    return ContactForm = (function() {
      class ContactForm extends Form {
        constructor(attrs, params, asLoad, ...args) {
          var col;
          super(attrs, params, asLoad, ...args);
          if ((!asLoad) && ((col = this.collection()) != null) && col.any((item) => {
            return item.attributes !== this.attributes && item.form_id() === this.form_id();
          })) {
            throw 'form not unique';
          }
        }

        toContactForm() {
          return this.dupe();
        }

        form_id() {
          return this.attributes.form_id;
        }

      };

      ContactForm.param = 'form';

      return ContactForm;

    }).call(this);
  }
]);

// coffeelint: enable
